import React, { ComponentProps } from 'react';

import { ScrollView, StyleSheet } from 'react-native';

import { useDraggableScroll } from './use-draggable-scroll';

export const DraggableScrollView = React.forwardRef<ScrollView, ComponentProps<typeof ScrollView>>(
  function DraggableScrollView(props, ref) {
    const refs = useDraggableScroll<ScrollView>({
      outerRef: ref,
    });

    return (
      <ScrollView
        ref={refs}
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.content}
        {...props}
      />
    );
  }
);

const styles = StyleSheet.create({ content: { width: '100%' } });
